import React from "react";
import { useSideTabs } from '../../hooks/useSideTabs';
import { useSelector } from "react-redux";
import { DisableRouteComponent } from "../../components/util/DisableRouteComponent";
import { IReduxAppState } from "../../reducers";
import moment from "moment"
import {  makeStyles } from "@material-ui/core";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { NoPermission } from "../../components/permissions/NoPermission";

const useStyles = makeStyles({
  ReviewsDiv:{
    width:"100%",
    height:"100%",
    "& >iframe":{
      width:"100%",
      height:"100%",
      border:"none"
    }
  }
});

const Reviews = (props: any) => {
  const position = useSideTabs(props.tab);
  const classes = useStyles();
  const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const VenueID = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueData?.id)!;

  const { hasPermission } = useCheckPermissions(props.requiredPermission);

  function getSrc() {
    const currentDateTime = moment.utc().add(24,"hours").format();
    const url = VenueID + "/" + currentDateTime;
    return "https://reviews.yoello.com/merchant?r=" + btoa(url) 
  }

  if(!hasPermission) {
    return <NoPermission permission={props.requiredPermission} />;;
  }
  
  return(<DisableRouteComponent pageKey={position}>
    <div className={classes.ReviewsDiv}>
    <iframe title="Merchant Dashboard Review" src={getSrc()}>

</iframe >
      </div>
</DisableRouteComponent>
    );
};

export default Reviews;
